import React from 'react';
import { useParams, Link } from 'react-router-dom';

const BlogPost = () => {
  const { id } = useParams();

  const posts = [
    {
      id: 'mosquito-tracking',
      title: 'Revolutionizing Vector Control with VectorScope',
      date: '2025-08-15',
      content: 'Our app leverages GPS and analytics for mosquito monitoring, impacting public health with AI predictions.',
    },
    {
      id: 'digital-health',
      title: 'The Future of Digital Health in Kenya',
      excerpt: 'AI-powered predictions and mobile apps for better outcomes.',
      date: '2025-07-10',
    },
    {
      id: 'sormas-dengue',
      title: 'Combating Dengue with SORMAS',
      date: '2025-06-20',
      content: 'Custom platform for real-time dengue tracking in coastal Kenya.',
    },
  ];

  const post = posts.find((p) => p.id === id);

  if (!post) {
    return (
      <section className="py-20 bg-gray-100">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4 text-blue-800">Post Not Found</h2>
          <Link to="/" className="text-teal-500 hover:underline">Back to Home</Link>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 bg-gray-100">
      <div className="container mx-auto px-4">
        <Link to="/" className="text-teal-500 hover:underline mb-4 inline-block">&larr; Back to Home</Link>
        <h1 className="text-4xl font-bold mb-4 text-blue-800">{post.title}</h1>
        <p className="text-gray-500 mb-6">{post.date}</p>
        <p className="text-gray-600 leading-relaxed">{post.content}</p>
      </div>
    </section>
  );
};

export default BlogPost;